import SidebarMenu, { sidebarSubmenu } from 'components/UI/layout/components/dashboardSidebar/SidebarMenu';
import routes from 'global/Constants/routes';
import { FC, ReactNode, useEffect, useMemo } from 'react';
import { BsBoxSeam } from 'react-icons/bs';
import { RxDashboard } from 'react-icons/rx';
// import { FiUsers } from 'react-icons/fi';
import { TeamOutlined } from '@ant-design/icons';
import { FaRegAddressBook, FaRegMoneyBillAlt } from 'react-icons/fa';
import { GoPackage } from 'react-icons/go';
import { MdOutlineCategory, MdOutlineMessage } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { getCustomerUser } from 'redux/reducer/user/getCustomerUser';
import { RootState, store } from 'redux/store';

type sideBarItem = {
  title: string;
  to?: string;
  icon: ReactNode;
  subMenu?: sidebarSubmenu[];
  isDisabled?: boolean;
  isExternalHref?: boolean;
};

const Sidebar: FC = () => {
  //state
  const { isAllowed } = useSelector((state: RootState) => state.user.userAllowed);
  const { userProfile, customerUser } = useSelector((state: RootState) => state.user);
  // const hasOwnerBranch = useMemo(() => {
  //   const branches = userProfile?.userBranches;
  //   if (!branches || branches.length === 0) return true;
  //   return branches.some((b) => b.isOwner === true);
  // }, [userProfile]);

  useEffect(() => {
    if (userProfile && !customerUser) store.dispatch(getCustomerUser(userProfile.id));
  }, [customerUser, userProfile]);

  //func
  const sideBarItems: sideBarItem[] = useMemo(() => {
    //constants
    const hiddenForLevel15 = new Set<string>(['ثبت سفارش', 'ارسال با مقصد لاکر جابار', 'مشتری ها', 'بسته‌ ها']);

    const hiddenForLevel10 = new Set<string>(['ثبت سفارش نمایندگی']);

    const filterSubMenuByAccess = (items?: sidebarSubmenu[]) => {
      if (!items || !items.length) return items;
      // customerTypeId === 2 (نمایندگی)
      if (customerUser?.customerTypeId === 2) {
        return items.filter((i) => !hiddenForLevel15.has(i.title));
      } else if (customerUser?.customerTypeId === 1) {
        return items.filter((i) => !hiddenForLevel10.has(i.title));
      }

      return items;
    };

    return [
      {
        title: 'داشبورد',
        isDisabled: false,
        icon: <RxDashboard />,
        to: routes.dashboardHome.path,
      },
      {
        title: 'سفارش',
        isDisabled: !isAllowed,
        icon: <BsBoxSeam />,
        subMenu: filterSubMenuByAccess([
          { title: 'ثبت سفارش', to: routes.orderSubmit.path },
          { title: 'ثبت سفارش نمایندگی', to: routes.orderSubmitForBranch.path },
          { title: 'ارسال با مقصد لاکر جابار', to: routes.lockerOrderSubmit.path },
          { title: 'لیست سفارش ها', to: routes.orderList.path },
          { title: 'لیست مرسوله ها', to: routes.parcelList.path },
          { title: 'در انتظار پرداخت', to: routes.unpaidOrder.path },
          { title: 'ثبت گروهی سفارش', to: routes.bulkOrderingByExcel.path },
          { title: 'ثبت سفارش باکس لاین', to: routes.ltlSteps.path },
          { title: 'لیست سفارشات باکس لاین', to: routes.ltlOrderList.path },
        ]),
      },
      {
        title: 'آدرس ها',
        isDisabled: !isAllowed,
        icon: <FaRegAddressBook />,
        subMenu: [
          { title: 'دفترچه آدرس فرستندگان', to: routes.senderAddress.path },
          { title: 'دفترچه آدرس گیرندگان', to: routes.recieverAddress.path },
        ],
      },
      ...(customerUser?.customerTypeId === 1
        ? [
            {
              title: 'مشتری ها',
              isDisabled: !isAllowed,
              icon: <TeamOutlined className='relative top-1' />,
              to: routes.client.path,
            },
          ]
        : []),
      // ...(customerUser?.customerTypeId === 1
      //   ? [
      {
        title: 'کالا',
        isDisabled: !isAllowed,
        icon: <MdOutlineCategory />,
        subMenu: [
          { title: 'نوع کالا', to: routes.productType.path },
          { title: 'کالا در انبار', to: routes.branchCustomerProductType.path },
        ],
      },

      {
        title: 'بسته‌ ها',
        isDisabled: !isAllowed,
        icon: <GoPackage />,
        to: routes.packaging.path,
      },
      //   ]
      // : []),
      {
        title: 'امورمالی',
        isDisabled: !isAllowed,
        icon: <FaRegMoneyBillAlt />,
        subMenu: [
          { title: 'گزارش مالی', to: routes.customerFinancial.path },
          { title: 'لیست تراکنش ها', to: routes.financeInvoice.path },
          { title: 'درخواست بازگشت وجه', to: routes.financeWalletRefund.path },
          { title: 'COD های پرداخت شده', to: routes.customerCodSettlementsList.path },
        ],
      },
    ];
  }, [isAllowed, userProfile, customerUser]);

  const isProductionServer = process.env.REACT_APP_NOD_ENV === 'production';

  if (isProductionServer)
    sideBarItems.push({
      title: 'تیکت',
      isDisabled: false,
      icon: <MdOutlineMessage />,
      to: routes.ticket.path,
    });

  const renderItems = useMemo(
    () =>
      sideBarItems.map((item) => (
        <SidebarMenu icon={item.icon} title={item.title} to={item.to} key={item.title} subMenu={item.subMenu} isDisable={item.isDisabled} isExternalHref={item.isExternalHref} />
      )),
    [sideBarItems, userProfile, customerUser]
  );

  return (
    <div>
      <div className='flex flex-col items-center gap-2 mx-2 my-2'>{renderItems}</div>
    </div>
  );
};

export default Sidebar;
